export default class EmailUtil {
    static onAddEmail(email, emailsToEdit, addEmail) {
        const mainEmail = emailsToEdit.find((emailToEdit) => emailToEdit.main)
        email.main = !mainEmail;
        addEmail(email)
    }
}
